import React from 'react'
import Header from '../Components/Navbar';
import tklogo from "../assets/tklogo.png"
import name from "../assets/tktext.png"
import { Container,Row,Col } from 'reactstrap';
import Countdown from '../Components/Countdown';
import { Link } from "react-router-dom";
import Footer from '../Components/Footer';
import useSound from 'use-sound';
import sfx from '../assets/click.mp3';
import GlitchClip from 'react-glitch-effect/core/GlitchClip';


const Home = ()=> {
    const [play] = useSound(sfx);
    return (
        <div className="mainpage">

            <Header></Header>
            <Container>
                <div className="main">
                    <img className="gif" alt="glitch" src="https://media.giphy.com/media/pjKjjJ4PkeLqqPSQLK/giphy.gif"></img>
                   
                        <Row>
                            <Col lg="3" md="3" xs="8" className="lg offset-lg-2 offset-md-2 offset-2">
                                
                                <img src={tklogo} alt="tklogo"></img>
                                
                            </Col>
                            <Col lg="5" md="5" xs="12" className="name">
                            
                                <img src={name} alt="tklogo"></img>
                            
                            </Col>
                        </Row>
                    <Countdown></Countdown>
                    
                </div>
                <div>
                <Row>
                    <Col md="4" xs="6" lg="4" className="mb-4 offset-lg-2 offset-md-2">
                        <GlitchClip onClick={play}>
                        <Link to="/live">
                            <div className="eventselect">
                            Live<br></br>Events
                            </div>
                        </Link>
                        </GlitchClip>
                    </Col>
                    <Col md="4" xs="6" lg="4" className="mb-4 ">
                        <GlitchClip onClick={play}>
                        <Link to="/online">
                            <div className="eventselect">
                            Online<br></br>Events
                            </div>
                        </Link>
                        </GlitchClip>
                    </Col>
                    </Row>
                </div>
            </Container>
            <Footer></Footer>
        </div>
    )
}
export default Home;